
interface IDiffResult {
    groupsCreated: number,
    groupsExcluded: number,
    userGroupsAdded: number,
    userGroupsRemoved: number,
    usersExcluded: number,
    usersProcessed: number
}

const DiffResultCard = ({value, title, isFullWidth, cardType}:{value: string, title: JSX.Element, isFullWidth?:boolean, cardType: string}) => {
    return (<div className={`diff-result-card ${isFullWidth && 'full-width '} ${cardType}`}>
        <p className={'title-text'}>{title}</p>
        <p className={'value-text'}>{value}</p>
    </div>)
}

const DiffResults = ({diff}:{diff: IDiffResult}) => {
    return (
        <>
            <div className={'diff-results-title-text'}>
                Your file has been successfully processed. Click 'Complete Group Sync' to confirm these changes and proceed,
                If any of the following numbers are unexpected, you can download and view your changes by clicking the
                'Download Diff' button
            </div>
            <div className={'diff-results-row'}>
                <DiffResultCard
                    cardType={"neutral"}
                    value={String(diff.usersProcessed)}
                    title={<>Total Users Processed</>}
                />
                <DiffResultCard
                    cardType={"neutral"}
                    value={String(diff.groupsCreated)}
                    title={<>New User Groups Created</>}
                />
            </div>
            <div className={'diff-results-row'}>
                <DiffResultCard
                    cardType={"positive"}
                    value={String(diff.userGroupsAdded)}
                    title={<>User Groups Added to Users</>}
                />
                <DiffResultCard
                    cardType={"negative"}
                    value={String(diff.userGroupsRemoved)}
                    title={<>User Groups Removed from Users</>}
                />
            </div>
            <div className={'diff-results-row'}>
                <DiffResultCard
                    cardType={"warning"}
                    value={`${diff.usersExcluded} users / ${diff.groupsExcluded} groups`}
                    title={<>Excluded from sync</>}
                    isFullWidth={true}
                />
            </div>
        </>
    )
}

export default DiffResults;